import React from "react";
import "./styles.css";
import { PageLayout } from "@BUP/components";
import { UserProfile } from "./UserProfile";

const ProfilePage = () => {
  return (
    <PageLayout pageName=" Mi Perfil">
      <div>
        <hr />
        <UserProfile />
      </div>
    </PageLayout>
  );
};

export default ProfilePage;
